export const caijingArticles = [
  {
    id: "caijing-1",
    title: "Pre-IPO突击入股疑云：一家独角兽估值虚高之谜",
    summary: "上市前夕的密集入股，让估值合理性成为焦点。我们从公开材料里找到了几处矛盾。",
    categoryId: "caijing",
    categoryName: "财经风云",
    publishedAt: "2026-10-12 08:10",
    source: "资本观察局",
    tags: ["IPO", "估值", "股权投资"],
    heat: 9120,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stylized%20financial%20district%20towers%20and%20rising%20chart%20lines%20in%20deep%20slate%20blue%20with%20orange%20highlights%2C%20minimal%20geometric%20illustration%2C%20professional%20editorial%20style%2C%20soft%20gradient%20background&width=1200&height=800&seq=focus-caijing-01&orientation=landscape",
    content: [
      "一家被市场寄予厚望的独角兽企业，在递交上市材料前夕出现了多笔密集入股。投资方的进入时点与估值变化，成为不少投资者关注的焦点。",
      "## 估值曲线为何陡峭",
      "从公开材料看，短短数月内，该企业的估值出现了明显跃升。若将其与同行业可比公司的估值水平对照，部分指标的合理性值得进一步说明。",
      "财务分析人士指出，突击入股本身并不必然违规，关键在于入股价格是否公允、信息披露是否充分。",
      "## 信息披露是关键",
      "受访的机构投资者表示，估值争议的本质是信息不对称。只有把交易背景、定价依据讲清楚，市场才能做出理性判断。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "caijing-2",
    title: "上市公司商誉暴雷前夜：审计机构为何集体失声",
    summary: "巨额商誉减值公告前，信号并非无迹可寻。我们回看了近几年的财报细节。",
    categoryId: "caijing",
    categoryName: "财经风云",
    publishedAt: "2026-10-11 10:25",
    source: "财报拆解组",
    tags: ["商誉减值", "审计", "财报"],
    heat: 8340,
    content: [
      "某上市公司近期发布业绩预亏公告，主要原因是大额商誉减值。公告一出，股价应声下跌，中小投资者反应强烈。",
      "## 信号早有端倪",
      "回看往年财报可以发现，被并购标的的业绩承诺完成率连续下滑，应收账款周转天数明显上升。这些早期信号当时并未引起足够重视。",
      "审计专业人士表示，商誉减值测试高度依赖管理层预期，若缺乏独立性约束，容易在风险积累后才集中释放。",
      "## 让减值更及时",
      "多位受访者建议，应强化对并购后整合与业绩承诺的持续披露，让风险更早被市场看到。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "caijing-3",
    title: "虚拟货币挖矿园区撤离之后：遗留的电费欠款该谁承担",
    summary: "矿场散去，留下的是空厂房与一笔笔欠费账单。当地如何处置这些遗留问题？",
    categoryId: "caijing",
    categoryName: "财经风云",
    publishedAt: "2026-10-10 17:50",
    source: "区域经济观察",
    tags: ["挖矿园区", "欠费", "遗留问题"],
    heat: 6210,
    content: [
      "随着相关整治推进，一些曾聚集大量矿机的园区陆续清退。矿场撤离后，遗留的电费欠款与设备处置问题浮出水面。",
      "## 欠款从何而来",
      "据当地供电部门反映，部分园区的用电主体注册信息与实际运营方并不一致，导致清退后出现追责困难。",
      "法律人士认为，此类问题涉及合同相对方认定，需要在处置时厘清各方责任，避免成本转嫁给地方和居民。",
      "## 清退之后更要善后",
      "有经济学者建议，在规范行业的同时，应同步建立退出机制，明确设备、债务与场地的处理路径。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "caijing-4",
    title: "私募爆雷潮追踪：那些承诺保本的理财产品去了哪",
    summary: "宣传中的“稳健保本”为何最终无法兑付？我们梳理了几类常见的风险话术。",
    categoryId: "caijing",
    categoryName: "财经风云",
    publishedAt: "2026-10-09 09:40",
    source: "投资者保护站",
    tags: ["私募", "风险", "理财"],
    heat: 7680,
    content: [
      "近一段时间，多只私募产品出现兑付困难，涉及金额不小。投资者普遍反映，当初购买时得到的是一份“听起来很稳”的承诺。",
      "## 三类常见风险话术",
      "梳理投诉材料可以看到，销售环节常见的话术包括强调历史收益、淡化风险等级、以及口头承诺兜底。这些话术往往难以形成书面证据。",
      "监管人士多次提示，任何承诺“保本保收益”的表述都存在误导风险，投资前务必核实产品备案与风险等级。",
      "## 理性投资是最好防护",
      "专业人士建议，投资者应分散配置、留好凭证，并在遇到问题时及时通过正规渠道维权。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "caijing-5",
    title: "直播间带货翻车调查：高退货率背后的选品黑幕",
    summary: "一场销售额亮眼的直播，退货率却高得异常。选品环节究竟发生了什么？",
    categoryId: "caijing",
    categoryName: "财经风云",
    publishedAt: "2026-10-08 20:15",
    source: "电商观察",
    tags: ["直播带货", "选品", "退货"],
    heat: 7120,
    content: [
      "直播带货的成交数据常被作为卖点，但部分场次的退货率却高得引人注意。高退货率背后，选品与质检环节的问题逐渐暴露。",
      "## 选品为何失守",
      "受访的供应链从业者表示，一些场次为追求低价和爆款，会压缩选品与质检时间，导致产品质量参差不齐。",
      "平台方则表示，正在通过提高准入门槛与售后抽查来改善体验，但执行仍需时间。",
      "## 数据好看不等于生意健康",
      "业内人士指出，健康的直播生态应把复购率与口碑放在成交额之前。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "caijing-6",
    title: "某连锁餐饮加盟骗局：加盟费交了却拿不到总部支持",
    summary: "签约前承诺满满，开业后支持全无。多位加盟商的经历呈现出相似的套路。",
    categoryId: "caijing",
    categoryName: "财经风云",
    publishedAt: "2026-10-07 16:35",
    source: "创业警示录",
    tags: ["加盟", "创业", "合同"],
    heat: 5590,
    content: [
      "多位加盟商反映，他们在缴纳加盟费后，并未获得签约时承诺的选址、培训与供应链支持，门店经营陷入困境。",
      "## 相似的加盟套路",
      "从多份合同看，支持内容多以“协助”“指导”等模糊措辞表述，缺乏可量化的义务约定，这为后续维权增加了难度。",
      "法律人士建议，创业者在签约前应实地考察直营门店经营状况，并将关键承诺写入合同附件。",
      "## 创业需警惕纸上蓝图",
      "多个行业报告提醒，加盟模式本身没有原罪，但信息不对称常让初次创业者踩坑。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
];